import Vue from "vue";
import Vuetify from "vuetify/lib";
import themes from "./themes";
import { getTheme } from "@/utils/get-theme";

Vue.use(Vuetify);

import ru from "vuetify/es5/locale/ru";
import en from "vuetify/es5/locale/en";
import fi from "./locales/fi";

export default new Vuetify({
  icons: {
    iconfont: "mdi"
  },
  theme: {
    themes: {
      light: getTheme(window.theme, themes)
    },
    options: {
      customProperties: true
    }
  },
  lang: {
    locales: { ru, en, fi },
    current: "ru"
  }
});
